export const privateLayoutStyles = (theme) => ({
  root: { height: '100vh', display: 'flex', flexDirection: 'column' },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.common.white,
    minHeight: '80px',
    padding: '0 2%',
  },
  headerLeftContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      order: '2',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
  },
  menu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch', // Cambio de 'center' a 'stretch'
    height: '100%', // Asegurar que ocupe toda la altura
    [theme.breakpoints.down('lg')]: {
      order: '1',
    },
  },
  headerRightContent: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      order: '3',
    },
  },
  bodyWrapper: { flex: 1, position: 'relative' },
  iconButton: { color: theme.palette.common.black },
})
